export const PHONE_REG = /^(\+\d{1,3}[- ]?)?\d{9,15}$/
export const EMAIL_REG = /^([\w-_]+(?:\.[\w-_]+)*)@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
